export default __webpack_public_path__ + "static/media/dsg-logo.c6bf53e7.png";